import { getDefaultFavoriteTreeData } from '../store/getDefaultFavoriteTreeData';
import { setFavoriteTreeData } from '../mutators/setFavoriteTreeData';
import favoritesStore from '../store/store';
import type { AccountKey } from 'owa-client-types';

export function initializeFavoriteTreeData(accountKey: AccountKey): void {
    if (!favoritesStore().favoriteTreeData.has(accountKey)) {
        setFavoriteTreeData(accountKey, getDefaultFavoriteTreeData(accountKey));
    }
}
